import { combineReducers } from 'redux';
import * as reducers from './reducers';

export const managerDashboard = combineReducers(reducers);
